import { render, staticRenderFns } from "./DisplayValue.vue?vue&type=template&id=4e942c0a&scoped=true&"
import script from "./DisplayValue.vue?vue&type=script&lang=js&"
export * from "./DisplayValue.vue?vue&type=script&lang=js&"
import style0 from "./DisplayValue.vue?vue&type=style&index=0&id=4e942c0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e942c0a",
  null
  
)

export default component.exports